import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

import ModuleQuestion from "../../components/ModuleQuestion";
import { SideBar } from "../../components/SideBar";
import { useSelector } from "react-redux";

import { ReactLoaderSpinner } from "../../components/ReactLoaderSpinner/index.js";

// services
import { useBookmarkModuleMutation } from "../../store/services/moduleServerApi";

const Module_4_1_5 = () => {
  const moduleNumber = 4;
  const { pathname: pathName } = useLocation();
  const { menuItems } = useSelector((state) => state?.moduleSlice);


  const [bookmarkModule, { isLoading: isMenuLoading }] =
    useBookmarkModuleMutation();

  /* Start useEffect */
  useEffect(() => {
    bookmarkModule({ pathName });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // * onPageLoad
  /* End useEffect */

  return (
    <div className="row">
      {isMenuLoading && <ReactLoaderSpinner />}
      {menuItems?.id && <SideBar menuItems={[menuItems]} moduleNumber={moduleNumber} />}

      <main className="col-sm-8 module-content">
        <section>
          <h1 className="blue text-uppercase b mt-5 mb-4">4.1.5 Case 5</h1>
          <p className="me-4">Estimated time to complete: 3-5 minutes</p>
        </section>
        <ModuleQuestion
          correctAnswer="B"
          assessmentName="challenge_case_5"
          videoTranscript={
            <>
              <p>
                <strong>AUDIO</strong>
                <br />
                VO: (FEMALE)
                <br />
                This is challenge case number 5. This is a negative case.
                Beginning in the occipital region seen here, focal uptake is
                seen in the posterior-most aspect. This uptake appears to be
                within the gray matter. However, if you were to utilize the
                accompanying fused PET/CT images and switched to bone windows,
                you would see that this in fact is within the bone.
              </p>
              <p>
                Immediately to the left of this uptake, and within the left
                occipital region, another focus of intense activity is seen.
                This also appears to be within the gray matter; however, it is
                important to evaluate the slices immediately adjacent to this.
                And immediately superior, it is clear that this activity is part
                of the white matter tracts.
              </p>
              <p>
                Continuing upwards, white matter tracts are more easily
                delineated on the left, as well as on the right, in the temporal
                and occipital region. Less intense activity is seen in the
                surrounding gray matter. There is no loss of gray-white contrast
                in the temporal or occipital regions.
              </p>
              <p>
                As we enter into the frontal and parietal cortices, identified here, there’s also preserved gray-white contrast. White matter tracts are easily delineated on the left- and right-hand side within both regions. After examining the remainder of the scan, there is preserved gray-white contrast as well. Therefore, this case is negative. If you called this case positive, you may want to review the case once again in the MIMcloud Viewer.
              </p>
            </>
          }
          previousLesson="/module-4/module-4-1-4"
          nextLesson="/module-4/module-4-1-6"
          iframeURL="https://cdnapisec.kaltura.com/p/1759891/sp/175989100/embedIframeJs/uiconf_id/24639831/partner_id/1759891?iframeembed=true&playerId=kaltura_player_1318818874&entry_id=1_joiegsqn&wid=_1759891&flashvars[sideBarContainer.plugin]=true&flashvars[sideBarContainer.position]=left&flashvars[sideBarContainer.clickToClose]=true&flashvars[chapters.plugin]=true&flashvars[chapters.layout]=vertical&flashvars[chapters.thumbnailRotator]=false&flashvars[streamSelector.plugin]=true&flashvars[EmbedPlayer.SpinnerTarget]=videoHolder&flashvars[dualScreen.plugin]=true"
          videoId="1_joiegsqn"
        />
      </main>
    </div>
  );
};

export default Module_4_1_5;
